import { useEffect, useMemo, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../Components/Button/Button';
import './ModalSolicitudDescargaHistorico.css';

const MESES_DUMMY = [
	{ value: '1', label: 'Enero' },
	{ value: '2', label: 'Febrero' },
	{ value: '3', label: 'Marzo' },
	{ value: '4', label: 'Abril' },
	{ value: '5', label: 'Mayo' },
	{ value: '6', label: 'Junio' },
	{ value: '7', label: 'Julio' },
	{ value: '8', label: 'Agosto' },
	{ value: '9', label: 'Septiembre' },
	{ value: '10', label: 'Octubre' },
	{ value: '11', label: 'Noviembre' },
	{ value: '12', label: 'Diciembre' },
];

const ANIOS_DUMMY = [
	{ value: '2026', label: '2026' },
	{ value: '2025', label: '2025' },
	{ value: '2024', label: '2024' },
	{ value: '2023', label: '2023' },
	{ value: '2022', label: '2022' },
	{ value: '2021', label: '2021' },
];

const TRIMESTRES_DUMMY = [
	{ value: '1', label: 'Q1' },
	{ value: '2', label: 'Q2' },
	{ value: '3', label: 'Q3' },
	{ value: '4', label: 'Q4' },
];

const TIPO_MENSUAL = 'mensual';
const TIPO_TRIMESTRAL = 'trimestral';

const getClosedQuarterCountForYear = (year) => {
	const currentDate = new Date();
	const selectedYear = Number(year);
	const currentYear = currentDate.getFullYear();

	if (!selectedYear || selectedYear > currentYear) {
		return 0;
	}

	if (selectedYear < currentYear) {
		return 4;
	}

	const currentMonth = currentDate.getMonth() + 1;

	if (currentMonth >= 10) {
		return 3;
	}

	if (currentMonth >= 7) {
		return 2;
	}

	if (currentMonth >= 4) {
		return 1;
	}

	return 0;
};

const ModalSolicitudDescargaHistorico = ({
	show,
	onHide,
	esFormatoEcxel,
	onConfirm,
}) => {
	const [tipoSeleccionado, setTipoSeleccionado] = useState('');
	const [filtroMensual, setFiltroMensual] = useState({ mes: '', anio: '' });
	const [filtroTrimestral, setFiltroTrimestral] = useState({ anio: '', trimestre: '' });

	useEffect(() => {
		if (!show) {
			setTipoSeleccionado('');
			setFiltroMensual({ mes: '', anio: '' });
			setFiltroTrimestral({ anio: '', trimestre: '' });
		}
	}, [show]);

	const ctaLabel = esFormatoEcxel ? 'Descargar Excel' : 'Descargar PDF';
	const closedQuarterCount = getClosedQuarterCountForYear(filtroTrimestral.anio);
	const trimestreOptions = useMemo(() => TRIMESTRES_DUMMY.map((item) => {
		const isDisabled = Number(item.value) > closedQuarterCount;

		return {
			...item,
			disabled: isDisabled,
			displayLabel: isDisabled ? `${item.label} - No disponible` : item.label,
		};
	}), [closedQuarterCount]);

	const isFormularioCompleto = useMemo(() => {
		if (tipoSeleccionado === TIPO_MENSUAL) {
			return Boolean(filtroMensual.mes && filtroMensual.anio);
		}

		if (tipoSeleccionado === TIPO_TRIMESTRAL) {
			return Boolean(filtroTrimestral.anio && filtroTrimestral.trimestre);
		}

		return false;
	}, [filtroMensual.anio, filtroMensual.mes, filtroTrimestral.anio, filtroTrimestral.trimestre, tipoSeleccionado]);

	useEffect(() => {
		if (!filtroTrimestral.trimestre) {
			return;
		}

		if (Number(filtroTrimestral.trimestre) > closedQuarterCount) {
			setFiltroTrimestral((previousState) => ({ ...previousState, trimestre: '' }));
		}
	}, [closedQuarterCount, filtroTrimestral.trimestre]);

	const handleHide = () => {
		onHide?.();
	};

	const handleSeleccionTipo = (tipo) => {
		setTipoSeleccionado((previousState) => previousState === tipo ? '' : tipo);
	};

	const handleDescargar = () => {
		if (tipoSeleccionado === TIPO_MENSUAL) {
			onConfirm?.({
				tipo: tipoSeleccionado,
				mes: Number(filtroMensual.mes),
				anio: Number(filtroMensual.anio),
			});
			return;
		}

		if (tipoSeleccionado === TIPO_TRIMESTRAL) {
			onConfirm?.({
				tipo: tipoSeleccionado,
				anio: Number(filtroTrimestral.anio),
				trimestre: Number(filtroTrimestral.trimestre),
			});
			return;
		}

		onHide?.();
	};

	return (
		<Modal
			show={show}
			onHide={handleHide}
			centered
			backdropClassName='backdrop-dark'
			dialogClassName='modal-descarga-historico-shell'
			contentClassName='modal-descarga-historico-content'
		>
			<Modal.Body className='modal-descarga-historico-body'>
				<div className='modal-descarga-historico'>
					<div className='modal-descarga-historico__header'>
						<h5 className='modal-descarga-historico__title'>Descarga de histórico</h5>
						<button
							type='button'
							className='modal-descarga-historico__close'
							onClick={handleHide}
							aria-label='Cerrar modal'
						>
							<i className='ico-close'></i>
						</button>
					</div>

					<p className='modal-descarga-historico__subtitle'>Selecciona el tipo de descarga</p>

					<div className='modal-descarga-historico__selection' role='radiogroup' aria-label='Tipo de descarga'>
						<label className='modal-descarga-historico__choice'>
							<input
								type='radio'
								name='tipoHistorico'
								checked={tipoSeleccionado === TIPO_MENSUAL}
								onChange={() => handleSeleccionTipo(TIPO_MENSUAL)}
							/>
							<span className='modal-descarga-historico__radio' aria-hidden='true'>
								<span className='modal-descarga-historico__radio-dot' />
							</span>
							<span className='modal-descarga-historico__choice-label'>Mensual</span>
						</label>

						<label className='modal-descarga-historico__choice'>
							<input
								type='radio'
								name='tipoHistorico'
								checked={tipoSeleccionado === TIPO_TRIMESTRAL}
								onChange={() => handleSeleccionTipo(TIPO_TRIMESTRAL)}
							/>
							<span className='modal-descarga-historico__radio' aria-hidden='true'>
								<span className='modal-descarga-historico__radio-dot' />
							</span>
							<span className='modal-descarga-historico__choice-label'>Trimestral</span>
						</label>
					</div>

					{tipoSeleccionado === TIPO_MENSUAL ? (
						<div className='modal-descarga-historico__filters'>
							<div className='modal-descarga-historico__field'>
								<label htmlFor='historico-mes'>Mes</label>
								<select
									id='historico-mes'
									value={filtroMensual.mes}
									onChange={(event) => setFiltroMensual((previousState) => ({ ...previousState, mes: event.target.value }))}
								>
									<option value=''>Seleccionar</option>
									{MESES_DUMMY.map((item) => (
										<option key={item.value} value={item.value}>
											{item.label}
										</option>
									))}
								</select>
							</div>

							<div className='modal-descarga-historico__field'>
								<label htmlFor='historico-anio-mensual'>Año</label>
								<select
									id='historico-anio-mensual'
									value={filtroMensual.anio}
									onChange={(event) => setFiltroMensual((previousState) => ({ ...previousState, anio: event.target.value }))}
								>
									<option value=''>Seleccionar</option>
									{ANIOS_DUMMY.map((item) => (
										<option key={item.value} value={item.value}>
											{item.label}
										</option>
									))}
								</select>
							</div>
						</div>
					) : null}

					{tipoSeleccionado === TIPO_TRIMESTRAL ? (
						<div className='modal-descarga-historico__filters'>
							<div className='modal-descarga-historico__field'>
								<label htmlFor='historico-anio-trimestral'>Año</label>
								<select
									id='historico-anio-trimestral'
									value={filtroTrimestral.anio}
									onChange={(event) => setFiltroTrimestral((previousState) => ({ ...previousState, anio: event.target.value }))}
								>
									<option value=''>Seleccionar</option>
									{ANIOS_DUMMY.map((item) => (
										<option key={item.value} value={item.value}>
											{item.label}
										</option>
									))}
								</select>
							</div>

							<div className='modal-descarga-historico__field'>
								<label htmlFor='historico-trimestre'>Trimestre</label>
								<select
									id='historico-trimestre'
									className={!filtroTrimestral.trimestre ? 'is-placeholder' : ''}
									value={filtroTrimestral.trimestre}
									onChange={(event) => setFiltroTrimestral((previousState) => ({ ...previousState, trimestre: event.target.value }))}
								>
									<option value=''>Seleccionar</option>
									{trimestreOptions.map((item) => (
										<option
											key={item.value}
											value={item.value}
											disabled={item.disabled}
										>
											{item.displayLabel}
										</option>
									))}
								</select>
							</div>
						</div>
					) : null}

					<div className='modal-descarga-historico__footer'>
						<Button
							type='button'
							design='btn-primary modal-descarga-historico__primary'
							onClick={handleDescargar}
							disabled={!isFormularioCompleto}
						>
							{ctaLabel}
						</Button>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default ModalSolicitudDescargaHistorico;
